import React, { useState, useEffect, useCallback } from 'react';
import { useNotify } from 'react-admin';
import { Api } from '../generated/Api';
import { config as appConfig } from '../config/config';
import { authService } from '../services/authService';

export const useTicketStatistics = () => {
  const notify = useNotify();
  const [api, setApi] = useState<Api<unknown> | null>(null);

  useEffect(() => {
    const apiInstance = new Api({
      baseURL: appConfig.apiUrl,
    });

    // ✅ UNIFICADO - Usar authService
    apiInstance.instance.interceptors.request.use(configReq => {
      const token = authService.getAccessToken();
      if (token) {
        configReq.headers.Authorization = `Bearer ${token}`;
      }
      return configReq;
    });

    // INTERCEPTOR DE RESPUESTA - MANEJA 401/403
    apiInstance.instance.interceptors.response.use(
      response => response,
      error => {
        const status = error.response?.status;

        if (status === 401 || status === 403) {
          console.log('🔄 Ticket Statistics API: Token inválido detectado');
          // ✅ UNIFICADO - Usar authService.logout()
          setTimeout(() => {
            authService.logout();
            if (window.location.pathname !== '/login') {
              window.location.href = '/login';
            }
          }, 100);
        }

        return Promise.reject(error);
      }
    );

    setApi(apiInstance);
  }, []);

  const getTicketStatistics = useCallback(async (): Promise<any> => {
    if (!api) return null;
    try {
      const response = await api.ticketsAdminStatisticsList();
      return response.data;
    } catch (error: any) {
      console.error('Error fetching ticket statistics:', error);

      // NO NOTIFICAR SI ES ERROR DE AUTENTICACIÓN
      if (error.response?.status !== 401 && error.response?.status !== 403) {
        notify('Error al cargar las estadísticas de tickets', {
          type: 'error',
        });
      }

      return null;
    }
  }, [api, notify]);

  return { getTicketStatistics, api };
};
